import { render, staticRenderFns } from "./KarmaCatalogue.vue?vue&type=template&id=f1cb8976&"
import script from "./KarmaCatalogue.vue?vue&type=script&lang=js&"
export * from "./KarmaCatalogue.vue?vue&type=script&lang=js&"
import style0 from "./KarmaCatalogue.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports